import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, NgModule, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DxFormModule, DxLoadIndicatorModule } from 'devextreme-angular';
import { WrapperStepperModule } from './stepperwrapper';
@Component({
  selector: 'app-create-account-form',
  templateUrl: './create-account-form.component.html',
  styleUrls: ['./create-account-form.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class CreateAccountFormComponent implements AfterViewInit{
  @ViewChild('step1Content') step1Content!: TemplateRef<any>;
  @ViewChild('step2Content') step2Content!: TemplateRef<any>;
  @ViewChild('step3Content') step3Content!: TemplateRef<any>;

  steps: { label: string, formGroup: FormGroup, content: TemplateRef<any> | null }[] = [];
  entityTypes = ['Registered Pty.', 'Other'];

  companyFormData = {
    entityType: '',
    companyName: '',
    registrationNumber: '',
    saccraNumber: '',
    ncrNumber: ''
  };

  contactAddressFormData = {
    contactPerson: '',
    phone: '',
    email: ''
  };

  addressFormData = {
    address: '',
    unitComplex: '',
    streetName: '',
    suburb: '',
    city: '',
    code: '',
    country: ''
  };

  constructor(private fb: FormBuilder) {
    this.steps = [
      { label: 'Step 1: Company Details', formGroup: this.createCompanyFormGroup(), content: null },
      { label: 'Step 2: Contact Details and Address', formGroup: this.createContactFormGroup(),  content: null },
      { label: 'Step 3: Address Details', formGroup: this.createAddressFormGroup(),content: null  }
    ];
  }


  
  ngAfterViewInit() {
    this.steps[0].content = this.step1Content;
    this.steps[1].content = this.step2Content;
    this.steps[2].content = this.step3Content;
  }

  createCompanyFormGroup(): FormGroup {
    return this.fb.group({
      entityType: ['', Validators.required],
      companyName: ['', Validators.required],
      registrationNumber: ['', Validators.required],
      saccraNumber: [''],
      ncrNumber: ['']
    });
  }

  createContactFormGroup(): FormGroup {
    return this.fb.group({
      contactPerson: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  createAddressFormGroup(): FormGroup {
    return this.fb.group({
      address: ['', Validators.required],
      unitComplex: [''],
      streetName: ['', Validators.required],
      suburb: [''],
      city: ['', Validators.required],
      code: ['', Validators.required],
      country: ['', Validators.required]
    });
  }

  onSubmit() {
    // Handle submit logic here
    console.log('Form submitted!');
  }

  // async onSubmitt(e: Event) {
  //   e.preventDefault();
  //   const { email, password } = this.formData;
  //   this.loading = true;

  //   const result = await this.authService.createAccount(email, password);
  //   this.loading = false;

  //   if (result.isOk) {
  //     this.router.navigate(['/login-form']);
  //   } else {
  //     notify(result.message, 'error', 2000);
  //   }
  // }

  // confirmPassword = (e: ValidationCallbackData) => {
  //   return e.value === this.formData.password;
  // }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
   DxLoadIndicatorModule,
   WrapperStepperModule
  ],
  declarations: [ CreateAccountFormComponent ],
  exports: [ CreateAccountFormComponent ]
})
export class CreateAccountFormModule { }

